import { render } from "./OrganisationDownloadDataPage.vue?vue&type=template&id=45ccb9f9"
import script from "./OrganisationDownloadDataPage.vue?vue&type=script&lang=js"
export * from "./OrganisationDownloadDataPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__